import React from 'react';
import PropTypes from 'prop-types';

import FormManager from 'src/core/gd-form/common/form-manager';

import CustomFieldAddFormProto from "../../add-form-proto";
import CustomFieldLeftPanel from "../../common/panel/form-left-panel";
import CustomFieldPreview from "../../common/form-preview";
import CustomFieldRightPanel from "core/fields/custom/common/panel/form-right-panel";
import UsersComponentProto from "./users-proto/users-proto";

export default class UsersCustomFieldForm extends CustomFieldAddFormProto {

    static propTypes = {
        customField: PropTypes.object,

        onSubmit: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);

        this.type = gd.const.customFields.type.USERS;

        this.form = new FormManager(this.formStructure, this.initFormData);
    }

    onSubmit(result) {
        result.name = result.name.trim();
        result.type = gd.const.customFields.type.USERS;

        result.params = {
            scope: result.scope
        };

        this.props.onSubmit(result);
    }

    render() {
        // get first two from company users
        const value = _.compact(gd.session.companyUsers.filterByCompany(this.props.organizationId).map(cu=>cu.user.id).slice(0,2));

        return (
            <React.Fragment>
                <CustomFieldLeftPanel parent={this}>
                    <CustomFieldPreview noPadding={true}>
                        <UsersComponentProto renderMode="view" value={value} canEdit={false}/>
                    </CustomFieldPreview>
                </CustomFieldLeftPanel>

                <CustomFieldRightPanel parent={this}/>
            </React.Fragment>
        )
    }
}